import React from "react";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import Contents from "../components/pages/chat/Contents";

const Chat = () => {
  return (
    <>
      <Header />
      <Contents />
      <Footer />
    </>
  );
};

export default Chat;
